import useFetchTemplateSettings from 'components/domain/automation/useFetchTemplateSettings';
import { LanguageCode } from 'i18n/internationalization.types';
import { UsageType } from 'models/automation/Common';

/**
 * Retrieves available languages based on the languages set within the template settings endpoint (Manage Languages
 * modal).
 */
const useAvailableLanguages = (usageType?: UsageType) => {
  const { data: templateSettings, isLoading } = useFetchTemplateSettings({
    usageType,
  });

  // adds english by default, if not present
  const availableLanguages = Array.from(
    new Set([LanguageCode.EN, ...(templateSettings?.locales ?? [])]),
  );

  return {
    availableLanguages,
    isLoading,
  };
};

export default useAvailableLanguages;
